import { render, staticRenderFns } from "./platconfig.vue?vue&type=template&id=4d1161fb&scoped=true"
import script from "./platconfig.vue?vue&type=script&lang=js"
export * from "./platconfig.vue?vue&type=script&lang=js"
import style0 from "./platconfig.vue?vue&type=style&index=0&id=4d1161fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1161fb",
  null
  
)

export default component.exports